import { get, post } from "../http/functions";

export const updateSystemMessageFn = async (message) => {
  try {
    const response = await post(
      `/system/alerts`,
      {
        message
      }
    );
    return {
      data: response?.data?.body
    }
  } catch (error) {
    return error?.error ? error : { error };
  }
};

export const getSystemMessageFn = async () => {
  try {
    const response = await get(`/system/alerts`);
    return {
      data: response?.data,
    };
  } catch (error) {
    return error?.error ? error : { error };
  }
};

export const getSessionsMetadata = async () => {
  try {
    const response = await get(`/session/metadata`);
    return {
      data: response?.data,
    };
  } catch (error) {
    return error?.error ? error : { error };
  }
};